import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorRightColumn" }
const _hoisted_2 = {
  key: 0,
  class: "WarningWidget WarningWidgetPrimary"
}
const _hoisted_3 = {
  key: 1,
  class: "CampaignEditorText CampaignEditorReadOnlyInputBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing }
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
        _createElementVNode("label", { class: "CampaignEditorInputLabel DropdownLabel CampaignSettingsInputRequired" }, " Campaign type ")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isCampaignCreation)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_MultiSelect, {
                ref: "campaignTypeDropdown",
                label: "Campaign Type",
                placeholder: " ",
                class: "CampaignEditorDropdown",
                options: _ctx.options,
                onUpdated: _ctx.setCampaignType
              }, null, 8 /* PROPS */, ["options", "onUpdated"]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ValidationMessage" }, " This field must be completed before proceeding ", -1 /* CACHED */)),
              (_ctx.isCampaignTypeCustomProductsOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("i", { class: "lnr-info WarningWidgetIcon" }, null, -1 /* CACHED */),
                    _createElementVNode("span", { class: "WarningWidgetOuterContentWrapper" }, " Keep in mind that, after clicking \"Create\", it is not possible to change the Campaign type. For the campaign type \"custom-products-only\", no organisations or studies can be attached and no listing budget can be set. ", -1 /* CACHED */)
                  ]))]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : (_ctx.nameOfSelectedCampaignType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.nameOfSelectedCampaignType), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["classes", "isLoading"]))
}